import { OtherString } from '../otherString';
import { z } from 'zod';

export const BasketIntegrityTrackingScannedItem = z.object({
    barcode: z.string(),
    itemId: z.string().nullish(),
    itemFound: z.boolean(),
    amountInSession: z.int(),
    relatedCodes: z.string().array().nullish(),
    createdOn: z.coerce.date(),
    siblingProducts: z.unknown().array().nullish(),
    replacedItemCheck: z.unknown().nullish(),
});
export type BasketIntegrityTrackingScannedItem = z.infer<typeof BasketIntegrityTrackingScannedItem>;

export const BasketIntegrityTrackingStatus = z.literal([
    'Pending',
    'Succeeded',
    'Cancelled',
    'PaymentCancelled',
    'Failed',
    'FailedContinued',
    'ImageDetectionsWrong',
]);
export type BasketIntegrityTrackingStatus = z.infer<typeof BasketIntegrityTrackingStatus>;

export const BasketIntegrityTracking = z.object({
    paymentRequestGuid: z.string(),
    sessionGuid: z.string().nullish(),
    storeGuid: z.string().nullish(),
    createdOn: z.coerce.date().nullish(),
    lastCreatedBy: z.string().nullish(),
    modifiedOn: z.coerce.date().nullish(),
    lastModifiedBy: z.string().nullish(),
    deletedOn: z.coerce.date().nullish(),
    nonHomogenous: z.boolean().nullish(),
    totalItemsToVerify: z.int().nullish(),
    totalPrice: z.number().nullish(),
    status: BasketIntegrityTrackingStatus.nullish(),
    cancelReason: z.literal('payment-cancelled').or(OtherString).nullish(),
    cartId: z.string().nullish(),
    scannedItems: BasketIntegrityTrackingScannedItem.array().nullish(),
});
export type BasketIntegrityTracking = z.infer<typeof BasketIntegrityTracking>;
